import type { DepositMode, StoreSettings, WaiverCollectionMode } from '@/lib/api/stores.js';

export const SETTINGS_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Detroit',
];

export const WEEKDAY_DEFAULTS = {
  monday: { open: '09:00', close: '18:00', closed: false },
  tuesday: { open: '09:00', close: '18:00', closed: false },
  wednesday: { open: '09:00', close: '18:00', closed: false },
  thursday: { open: '09:00', close: '18:00', closed: false },
  friday: { open: '09:00', close: '18:00', closed: false },
  saturday: { open: '10:00', close: '17:00', closed: false },
  sunday: { open: '10:00', close: '17:00', closed: true },
};

export type WeekdayHours = typeof WEEKDAY_DEFAULTS;

export function toBool(value: unknown, fallback = false): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

export function nullableText(value: string): string | null {
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

export function nonEmptyText(value: string, fallback: string): string {
  const trimmed = value.trim();
  return trimmed || fallback;
}

export function numericValue(value: string, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function positiveInteger(value: string, fallback: number): number {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export function depositModeValue(value: string): DepositMode {
  return value === 'none' || value === 'required' || value === 'rule_based' ? value : 'optional';
}

export function waiverCollectionModeValue(value: string): WaiverCollectionMode {
  return value === 'hand_across' || value === 'sms_link' ? value : 'customer_display';
}

export function storeField(
  store: StoreSettings | undefined,
  key: keyof StoreSettings,
  fallback = '',
): string {
  const value = store?.[key];
  return value === null || value === undefined ? fallback : String(value);
}

export function buildStoreHoursPayload(
  savedHours: WeekdayHours,
  form: Record<string, string>,
): Record<string, { open: string; close: string; closed: boolean }> {
  return Object.fromEntries(
    Object.entries(savedHours).map(([day, hours]) => [
      day,
      {
        open: form[`hours.${day}.open`] ?? hours.open,
        close: form[`hours.${day}.close`] ?? hours.close,
        closed:
          form[`hours.${day}.closed`] === 'true'
            ? true
            : form[`hours.${day}.closed`] === 'false'
              ? false
              : hours.closed,
      },
    ]),
  );
}
